module.exports = __webpack_public_path__ + "static/media/trending_up.1161e0ce.svg";